import axios from "axios";

const apiUsuario = axios.create({
  baseURL: process.env.REACT_APP_URL_APP_SDS,
});

apiUsuario.defaults.validateStatus = () => true;

export default apiUsuario;
